import { render, staticRenderFns } from "./CardExressEdit.vue?vue&type=template&id=4e6da870&scoped=true&"
import script from "./CardExressEdit.vue?vue&type=script&lang=js&"
export * from "./CardExressEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardExressEdit.vue?vue&type=style&index=0&id=4e6da870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6da870",
  null
  
)

export default component.exports